import { useState } from "react";
import { toast } from "sonner";
import api, { errMsg } from "@/lib/api";
import { Field, VinField, inp, btn, btn2 } from "@/components/shop/ShopShell";

const EMPTY = { vin: "", year: "", make: "", model: "", trim: "", engine: "", plate: "", mileage: 0, customer_name: "", customer_phone: "", customer_email: "" };

export const VehicleForm = ({ onSaved, onCancel }) => {
  const [f, setF] = useState(EMPTY);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const save = async () => {
    try { const { data } = await api.post("/api/shop/vehicles", { ...f, mileage: Number(f.mileage) || 0 }); toast.success("Vehicle profile created"); onSaved(data); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="space-y-3" data-testid="vehicle-form">
      <Field label="VIN"><VinField value={f.vin} onChange={(vin) => setF({ ...f, vin })} onDecoded={(d) => setF({ ...f, ...d })} /></Field>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
        {[["year", "Year"], ["make", "Make"], ["model", "Model"], ["trim", "Trim"], ["engine", "Engine"], ["plate", "Plate"], ["mileage", "Mileage"]].map(([k, l]) => <Field key={k} label={l}><input value={f[k]} onChange={set(k)} className={inp} data-testid={`veh-${k}`} /></Field>)}
      </div>
      <div className="grid sm:grid-cols-3 gap-2">
        <Field label="Customer name"><input value={f.customer_name} onChange={set("customer_name")} className={inp} data-testid="veh-customer_name" /></Field>
        <Field label="Phone"><input value={f.customer_phone} onChange={set("customer_phone")} className={inp} data-testid="veh-customer_phone" /></Field>
        <Field label="Email"><input value={f.customer_email} onChange={set("customer_email")} className={inp} data-testid="veh-customer_email" /></Field>
      </div>
      <div className="flex gap-2"><button onClick={save} disabled={!f.make || !f.customer_name} className={btn} data-testid="veh-save">Save vehicle</button>{onCancel && <button onClick={onCancel} className={btn2} data-testid="veh-cancel">Cancel</button>}</div>
    </div>
  );
};
